export default {
  props: {
    /**
     * show or hide REMOVE button in actions column
     */
    enableRemove: {
      type: Boolean,
      default: false
    },

    /**
     * show or hide ADD button in actions column
     */
    enableAdd: {
      type: Boolean,
      default: false
    },

    showTitle: {
      type: Boolean,
      default: true
    },

    /**
     * show or hide search input field
     */
    enableSearch: {
      type: Boolean,
      default: false
    },

    /**
     * fields to use when using search to filter through elements
     * of entity array
     */
    searchFields: {
      type: Array,
      default: () => []
    },

    searchPlaceholder: {
      type: String,
      default: "Type something here..."
    },

    emptyMessage: {
      type: String,
      default: "No Results Found."
    },

    // this is primarily used to check if data is loading
    // before displaying the empty message
    // the tile loaders work better visually than the table loader
    loading: {
      type: Boolean,
      default: false
    }
  }
};
